import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Sizes } from '@ratehub/base-ui';

import { CARD_IMAGE_WIDTH, HORIZONTAL_WHITE_SPACE } from '../definitions/Layout';
import SummaryDetailsSelector from './SummaryDetailsSelector';
import ExpandableCardDetailsTable from './ExpandableCardDetailsTable';


function HeaderDetailsBlock({ cardInfo }) {
    return (
        <Container>
            <div className="indentation-placeholder" />

            <div className="details-wrapper">
                <SummaryDetailsSelector
                    className="summary-details"
                    cardInfo={cardInfo}
                />

                <ExpandableCardDetailsTable cardInfo={cardInfo} />
            </div>
        </Container>
    );
}


HeaderDetailsBlock.propTypes = {
    cardInfo: PropTypes.object.isRequired,
};


const Container = styled.div`
    display: flex;
    flex-wrap: wrap-reverse;
    margin-left: ${HORIZONTAL_WHITE_SPACE};
    margin-bottom: ${Sizes.SPACING.TWO};
    
    > .indentation-placeholder {  
        flex: 0 0 14em;   /* I see you IE and you’re 💩! */
        flex: 0 0 calc(${CARD_IMAGE_WIDTH} + ${HORIZONTAL_WHITE_SPACE});
        
        height: 0.5px;
    }
    
    > .details-wrapper {        
        flex: 1 1 40em;
        /* would need to share the concept of mobile layout to know when to eliminate this right margin */
        margin-right: ${HORIZONTAL_WHITE_SPACE};
        
        > .summary-details {
            max-width: 40em;
        }            
    }
`;

export default HeaderDetailsBlock;
